<div class="marg-bottom-20 bg-warning padd-h-10 padd-v-10 border-radius-3">
    <span class="col-warning subtitle">
        <mat-icon class="mat-icon material-icons mat-icon-small marg-right-10 col-warning">warning</mat-icon>
        {{'IMPERSONATING'|translate}}
    </span>
    <p class="text-small">{{'IMPERSONATE_CONFIRM_DESC'|translate}}</p>
</div>